/**
 * Azure Blob Storage Configuration
 * 
 * This file contains configuration for Azure Blob Storage uploads.
 * Update these settings based on your Azure Storage setup.
 */

// Azure Blob Storage Configuration
export const BLOB_STORAGE_CONFIG = {
  // Storage account name
  storageAccount: 'starapps',
  
  // Container name
  containerName: 'multi-sites',
  
  // Base path for demo request uploads
  basePath: 'contacts',
  
  // API endpoint for getting SAS tokens (if using backend authentication)
  sasTokenEndpoint: '/api/get-sas-token',
  
  // Whether to use simulated uploads when no authentication is available
  enableSimulatedUploads: true,
  
  // Default SAS token (for development/testing - not recommended for production)
  // In production, this should be null and tokens should be obtained from your backend
  defaultSasToken: 'sp=racwl&st=2025-09-19T18:26:54Z&se=2125-09-20T02:41:54Z&spr=https&sv=2024-11-04&sr=c&sig=BwkYT1ctKaql0RZAMNgbLF3MUgouuXigOarYEj5Qzp8%3D',
  
  // Blob storage API version
  apiVersion: '2020-04-08'
};

/**
 * Gets the full blob storage URL for a given path
 * @param {string} domainId - Domain identifier
 * @param {string} filename - Filename
 * @returns {string} - Full blob storage URL
 */
export const getBlobStorageUrl = (domainId, filename) => {
  const { storageAccount, containerName, basePath } = BLOB_STORAGE_CONFIG;
  const blobPath = `${basePath}/${domainId}/${filename}`;
  
  return `https://${storageAccount}.blob.core.windows.net/${containerName}/${blobPath}`;
};

/**
 * Gets SAS token from backend API
 * @returns {Promise<string|null>} - SAS token or null if not available
 */
export const getSasTokenFromBackend = async () => {
  try {
    const { sasTokenEndpoint } = BLOB_STORAGE_CONFIG;
    
    if (!sasTokenEndpoint) {
      return null;
    }
    
    const response = await fetch(sasTokenEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      return data.sasToken || null;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

/**
 * Gets the configured SAS token (from config or backend)
 * @returns {Promise<string|null>} - SAS token or null if not available
 */
export const getConfiguredSasToken = async () => {
  const { defaultSasToken } = BLOB_STORAGE_CONFIG;
  
  // If a default SAS token is configured, use it
  if (defaultSasToken) {
    return defaultSasToken;
  }
  
  // Otherwise, try to get one from the backend
  return await getSasTokenFromBackend();
};
